import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import Link from '../Link'
import useWindowSize from '../../hooks/useWindowSize'

import GbiBridged from '../GbiBridged'

import {
  sensorTechnologyContainer,
  sensorTechnologyInnerContainer,
  headerBlock,
  titleBlock,
  subtitleBlock,
  ctaBlock,
  imageWrapper,
  slickItemWrapper,
  imageBlock,
  imageArea,
  image,
  imageTitle,
  imageSubtitle,
  block1,
  block2,
  block3,
  line1,
  line2,
  line3,
  dotWrapper,
  circle,
} from './index.module.css'

const Circle = ({ top = 0, left = 'unset', right = 'unset' }) => {
  return (
    <div className={dotWrapper} style={{ top, left, right }}>
      <div className={circle} />
    </div>
  )
}

const SensorTechnology = ({
  title,
  subtitle,
  images,
  ctaText,
  ctaUrl,
  components,
}) => {
  // eslint-disable-next-line
  const size = useWindowSize()

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const backgroundImage = size.width < 834 ? images[0]?.gatsbyImageData : {}

  return (
    <div
      className={[sensorTechnologyContainer, 'sensorTechnologyContainer'].join(
        ' '
      )}
    >
      <div className={sensorTechnologyInnerContainer}>
        <div className={headerBlock}>
          <h2 className={titleBlock}>{title && title}</h2>
          <p className={`${subtitleBlock} paragraph`}>{subtitle?.subtitle}</p>
          {ctaText && ctaUrl && (
            <Link className={ctaBlock} to={ctaUrl}>
              {ctaText}
            </Link>
          )}
        </div>

        {size.width < 1440 && size.width >= 834 && (
          <div className={imageBlock}>
            <GatsbyImage
              image={images[0]?.iphero}
              className={image}
              imgStyle={{
                objectFit: 'contain',
                objectPosition: '50% 50%',
              }}
              alt={images[0]?.description}
            />
            <div className={line1} />
            <Circle top={188} left={190} />
            <div className={block1}>
              <h4 className={imageTitle}>{components[0]?.title}</h4>
              <p className="paragraph">{components[0]?.subtitle?.subtitle}</p>
            </div>
            <div className={line2} />
            <Circle top={333} right={416} />
            <div className={block2}>
              <h4 className={imageTitle}>{components[1]?.title}</h4>
              <p className="paragraph">{components[1]?.subtitle?.subtitle}</p>
            </div>
            <div className={line3} />
            <Circle top={238} right={374} />
            <div className={block3}>
              <h4 className={imageTitle}>{components[2]?.title}</h4>
              <p className="paragraph">{components[2]?.subtitle?.subtitle}</p>
            </div>
          </div>
        )}

        {size.width >= 1440 && (
          <div className={imageBlock}>
            <GatsbyImage
              image={images[0]?.iphero}
              className={image}
              imgStyle={{
                objectFit: 'contain',
                objectPosition: '50% 50%',
              }}
              alt={images[0]?.description}
            />
            <div className={line1} />
            <Circle top={226} left={239} />
            <div className={block1}>
              <h4 className={imageTitle}>{components[0]?.title}</h4>
              <p className="paragraph">{components[0]?.subtitle?.subtitle}</p>
            </div>
            <div className={line2} />
            <Circle top={411} right={518} />
            <div className={block2}>
              <h4 className={imageTitle}>{components[1]?.title}</h4>
              <p className="paragraph">{components[1]?.subtitle?.subtitle}</p>
            </div>
            <div className={line3} />
            <Circle top={312} right={468} />
            <div className={block3}>
              <h4 className={imageTitle}>{components[2]?.title}</h4>
              <p className="paragraph">{components[2]?.subtitle?.subtitle}</p>
            </div>
          </div>
        )}

        <GbiBridged
          className={imageWrapper}
          source={backgroundImage}
          height={'100%'}
          width={'100%'}
          objectFit={'contain'}
          backgroundStyles={{
            backgroundSize: '330px 350px',
            backgroundPosition: '50% 0%',
          }}
        >
          {size.width < 834 && (
            <>
              <Slider className="slick" {...settings}>
                <div key={1}>
                  <div className={slickItemWrapper}>
                    <div className={imageBlock}>
                      <div className={imageArea}></div>
                      <div className={line1} />
                      <Circle top={129} left={119} />
                      <h4 className={imageTitle}>{components[0]?.title}</h4>
                      <p className={`${imageSubtitle} paragraph`}>
                        {components[0]?.subtitle?.subtitle}
                      </p>
                    </div>
                  </div>
                </div>

                <div key={2}>
                  <div className={slickItemWrapper}>
                    <div className={imageBlock}>
                      <div className={imageArea}></div>
                      <div className={line2} />
                      <Circle top={198} left={38} />
                      <h4 className={imageTitle}>{components[1]?.title}</h4>
                      <p className={`${imageSubtitle} paragraph`}>
                        {components[1]?.subtitle?.subtitle}
                      </p>
                    </div>
                  </div>
                </div>
                <div key={3}>
                  <div className={slickItemWrapper}>
                    <div className={imageBlock}>
                      <div className={imageArea}></div>
                      <div className={line3} />
                      <Circle top={172} left={73} />
                      <h4 className={imageTitle}>{components[2]?.title}</h4>
                      <p className={`${imageSubtitle} paragraph`}>
                        {components[2]?.subtitle?.subtitle}
                      </p>
                    </div>
                  </div>
                </div>
              </Slider>
            </>
          )}
        </GbiBridged>
      </div>
    </div>
  )
}

export default SensorTechnology
